import EventEmitter from 'eventemitter3';

export default class DateLeftManager extends EventEmitter {

    _styleConsole = 'background: #222; color: #ff8c8c';
    _classes = {
        container: 'js-date-left-container',
        dateList: 'js-date-list',
        dateContent: 'js-date-content',
        dateItem: 'js-date-item',
        dateLabel: 'js-date-label',
        dateProgressBar: 'js-date-progress-bar',
        dateScroll: 'js-date-scroll',
        dateButton: 'js-date-button',
        hide: 'hide',
        open: 'open',
        active: 'active',
        animScrollExist: 'anim-scroll-exist',
        scroll: 'is-scrolling',
        initLoad: 'anim-init-load'
    };
    _isScrolling = false;
    _isDateClicked = false;
    _isHover = false;
    _deltaY = 0;
    _heightDateList = 0;
    _heightDateScroll = 0;
    _limitMinDate = 5;
    _animDateExist = false;
    _animScrollExist = false;
    _heightDateContentClose = 0;
    _isOpen = false;
    _TimelineLabel = {
        open: '',
        close: ''
    }

    _date = {
        old: 0,
        current: 0,
        next: 0
    }

    constructor() {
        super();

        this._isDesktop = ( ENV.template == 'desktop' );

        this._retrieveDOM();
        this.bind();
    }

    _retrieveDOM() {

        this._views = {};

        this._views.container = document.body.querySelector( '.' + this._classes.container ) ;

        this._views.date = {
            containerList : this._views.container.querySelector( '.' + this._classes.dateList ),
            containerContent : null,
            containerScroll: null,
            items : null,
            labels : null,
            progressBar : null
        };
        this._views.date.containerContent = this._views.date.containerList.querySelector( '.' + this._classes.dateContent );
        this._views.date.containerScroll = this._views.date.containerList.querySelector( '.' + this._classes.dateScroll );
        this._views.date.items = [].slice.call( this._views.date.containerList.querySelectorAll( '.' + this._classes.dateItem ) );
        this._views.date.labels = [].slice.call( this._views.date.containerList.querySelectorAll( '.' + this._classes.dateLabel ) );
        this._views.date.progressBar = [].slice.call( this._views.date.containerList.querySelectorAll( '.' + this._classes.dateProgressBar ) );

        if( this._isDesktop == false ) {
            this._views.date.button = this._views.container.querySelector( '.' + this._classes.dateButton );
        }

        this._initDataDOM();
    }

    _initDataDOM() {

        if( this._isDesktop ) {
            this._heightDateContentClose = this._views.date.containerContent.getBoundingClientRect().height;
            this._animDateExist = ( this._views.date.items.length > this._limitMinDate );
        }

        if( this._isDesktop == false ) {
            this._TimelineLabel.open = this._views.date.button.dataset.labelOpen;
            this._TimelineLabel.close = this._views.date.button.innerHTML;
        }
    }

    bind() {

        for( let i = 0, j = this._views.date.items.length; i<j; i++ ) {
            this._views.date.labels[i].addEventListener( 'click', this._clickDate.bind( this ) );
        }

        if( this._isDesktop ) {
            if( this._animDateExist ) {
                this._views.date.containerList.addEventListener( 'mouseenter', this._enterDateArea.bind( this ) );
                this._views.date.containerList.addEventListener( 'mouseleave', this._leaveDateArea.bind( this ) );

                this._views.date.containerList.addEventListener( 'mousedown', this._startScrollDate.bind( this ) );
                this._views.date.containerList.addEventListener( 'mousemove', this._scrollDate.bind( this ) );
                this._views.date.containerList.addEventListener( 'mouseup', this._stopScrollDate.bind( this ) );
            }
        }

        if( this._isDesktop == false ) {
            this._views.date.button.addEventListener( 'click', this._clickButtonDate.bind( this ) );
        }
    }

    _clickButtonDate( event ) {

        if( this._isOpen ) {
            this._closeDate();
        } else {
            this._openDate();
        }
    }

    _openDate() {
        this._isOpen = true;

        document.body.classList.add('no-scroll');
        this._views.container.classList.add( 'open' );
        this._views.date.button.innerHTML = this._TimelineLabel.open;
    }

    _closeDate() {
        this._isOpen = false;

        document.body.classList.remove('no-scroll');
        this._views.container.classList.remove( 'open' );
        this._views.date.button.innerHTML = this._TimelineLabel.close;
    }

    _initClass() {

        this._views.date.items[ this._date.current ].classList.add( this._classes.active );

        if( this._isDesktop ) {
            this._setDataHeightElement();

            this._setPosCenterDateActive();
        }
    }

    initLoad() {
        this._views.container.classList.remove( this._classes.initLoad );
    }

    show() {
        this._views.container.classList.remove( this._classes.hide );
    }

    hide() {
        this._views.container.classList.add( this._classes.hide );
    }

    _enterDateArea( event ) {
        this._isHover = true;

        // let test = new TimelineMax();
        // test
        //     .to( this._views.date.containerScroll, 0.3, { autoAlpha: 0 })
        //     .to( this._views.date.containerList, 0.3, { height: '100%', y: '-50%', padding : 0 } )
        //     .to( this._views.date.containerScroll, 0.3, { autoAlpha: 1 })

        // TweenMax.to( this._views.date.containerScroll, 0.2, { autoAlpha: 0, onComplete: () => {
        //
        //         TweenMax.to( this._views.date.containerScroll, 0.2, { autoAlpha: 1, delay: 0.8 } );
        //     } } );


        this._views.date.containerList.classList.add( this._classes.open );

        if( this._animScrollExist ) {
            this._views.date.containerContent.style.removeProperty('height');
            this._setPosContainerScroll();
        } else {
            this._views.date.containerContent.style.height = this._heightDateScroll + 'px';
            TweenMax.to( this._views.date.containerScroll, 0.5, { y : 0, ease: Power1.easeOut } );
        }
    }

    _leaveDateArea( event ) {
        this._isHover = false;

        this._views.date.containerList.classList.remove( this._classes.open );

        if( this._animScrollExist ) {
            this._deltaY = 0;
        } else {
            this._views.date.containerContent.style.height = this._heightDateContentClose + 'px';
        }

        this._setPosCenterDateActive();
    }

    _startScrollDate( event ) {
        this._isScrolling = true;

        if( this._animScrollExist ) {
            this._views.date.containerList.classList.add( this._classes.scroll );
            this._scrollY = event.clientY;
        }
    }

    _scrollDate( event ) {

        if( this._isScrolling && this._animScrollExist ) {

            let difference_pixel = event.clientY - this._scrollY;
            this._deltaY += difference_pixel;

            this._scrollY = event.clientY;

            this._deltaY = Math.min( 0, this._deltaY );

            this._deltaY = Math.max( this._diffHeightElement * -1, this._deltaY );

            TweenMax.to( this._views.date.containerScroll, 0.1, { y : this._deltaY, ease: Power1.easeOut } );
        }
    }

    _stopScrollDate( event ) {

        this._isScrolling = false;

        if( this._animScrollExist ) {
            this._views.date.containerList.classList.remove( this._classes.scroll );
        }
    }

    _clickDate( event ) {

        if( this._isScrolling == false || this._isDesktop == false ) {

            let target = event.currentTarget;
            let index = this._views.date.labels.indexOf( target );

            if( index != this._date.current ) {

                if( this._isDateClicked )
                    return;

                this._isDateClicked = true;

                this.emit( DATE_LEFT_MANAGER_EVENT.CLICK_DATE, index );

                if( this._isDesktop == false ) {
                    this._closeDate();
                }
            }
        }
    }

    _endAnimDateClicked() {
        this._isDateClicked = false;
    }

    setIndex( index ) {
        this._date = index;
    }

    _updateDate( direction ) {
        this._views.date.items[ this._date.old ].classList.remove( this._classes.active );
        this._views.date.items[ this._date.current ].classList.add( this._classes.active );

        if( this._isDesktop ) {
            if( this._isHover == false ) {
                this._setPosCenterDateActive();
            }
        }

        this._setProgressBar( direction );
    }

    _setProgressBar( direction ) {

        if( direction == 'next' ) {
            this._views.date.progressBar[ this._date.old ].style.transform = 'scaleX(1)';
            this._views.date.progressBar[ this._date.current ].style.transform = 'scaleX(0)';
        }

        if( direction == 'prev' ) {
            this._views.date.progressBar[ this._date.old ].style.transform = 'scaleX(0)';
            this._views.date.progressBar[ this._date.current ].style.transform = 'scaleX(1)';
        }
    }

    _updateCurrentProgressBar( value ) {
        TweenMax.to( this._views.date.progressBar[ this._date.current ], 0.2, { scaleX : value, ease: Power1.easeOut } );
    }

    resize() {

        if( this._isDesktop ) {
            this._setDataHeightElement();
        }
    }

    _setDataHeightElement() {
        this._getHeightElement();
        this._compareHeightElement();
        this._getDifferenceHeightElement();
    }

    _getHeightElement() {
        this._heightDateList = this._views.date.containerList.getBoundingClientRect().height;
        this._heightDateScroll = this._views.date.containerScroll.getBoundingClientRect().height;
    }

    _compareHeightElement() {
        this._animScrollExist = ( this._heightDateScroll  > this._heightDateList );

        if( this._animScrollExist ) {
            this._views.date.containerList.classList.add( this._classes.animScrollExist );
        } else {
            this._views.date.containerList.classList.remove( this._classes.animScrollExist );
        }
    }

    _getDifferenceHeightElement() {
        this._diffHeightElement = this._heightDateScroll - this._heightDateList;
    }

    _setPosCenterDateActive() {

        let posYDateActive = this._views.date.items[ this._date.current ].getBoundingClientRect().top + ( this._views.date.items[ this._date.current ].getBoundingClientRect().height / 2 );
        let posDateActive = posYDateActive - this._views.date.containerScroll.getBoundingClientRect().top;

        let halfHeightContentClose = this._heightDateContentClose / 2;
        let marge = 10;
        this._deltaY = (-1 * posDateActive ) + halfHeightContentClose - marge;

        // TweenMax.to( this._views.date.containerScroll, 0.3, { y : this._deltaY, ease: Power1.easeOut } )
        TweenMax.to( this._views.date.containerScroll, 0.5, { y : this._deltaY, ease: Power1.easeOut } );
        // this._views.date.containerScroll.style.transform = 'translateY(' + this._deltaY + 'px)';
    }

    _setPosContainerScroll() {

        let posYDateActive = this._views.date.items[ this._date.current ].getBoundingClientRect().top + ( this._views.date.items[ this._date.current ].getBoundingClientRect().height / 2 );
        let posDateActive = posYDateActive - this._views.date.containerScroll.getBoundingClientRect().top;

        let halfHeightContentOpen = this._heightDateList / 2;
        let marge = 10;
        this._deltaY = (-1 * posDateActive ) + halfHeightContentOpen - marge - 70;

        this._deltaY = Math.min( 0, this._deltaY );
        this._deltaY = Math.max( this._diffHeightElement * -1, this._deltaY );

        TweenMax.to( this._views.date.containerScroll, 0.5, { y : this._deltaY, ease: Power1.easeOut } );
        // this._views.date.containerScroll.style.transform = 'translateY(' + this._deltaY + 'px)';
    }

}



export const DATE_LEFT_MANAGER_EVENT = {
    'CLICK_DATE' : '__dlm_click_date',
}


// WEBPACK FOOTER //
// ./src/js/pages/history/modules/date-left-manager.js